import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="type-approval-actions"
export default class extends Controller {
  static values = { 
    certificate: String,
    approvalData: Object
  }

  copyCertificate(event) {
    event.preventDefault()
    
    navigator.clipboard.writeText(this.certificateValue)
      .then(() => {
        this.showNotification("Certificate number copied to clipboard!")
      })
      .catch((err) => {
        console.error("Failed to copy:", err)
        this.showNotification("Failed to copy certificate", "error")
      })
  }

  copyJson(event) {
    event.preventDefault()
    
    const jsonContent = JSON.stringify(this.approvalDataValue, null, 2)
    
    navigator.clipboard.writeText(jsonContent)
      .then(() => {
        this.showNotification("JSON copied to clipboard!")
      })
      .catch((err) => {
        console.error("Failed to copy:", err)
        this.showNotification("Failed to copy JSON", "error")
      })
  }

  exportJson(event) {
    event.preventDefault()
    
    // Create a JSON blob
    const jsonData = JSON.stringify(this.approvalDataValue, null, 2)
    const blob = new Blob([jsonData], { type: "application/json" })
    
    // Create download link
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = `type_approval_${this.certificateValue || 'data'}.json`
    
    // Trigger download
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    
    // Clean up
    URL.revokeObjectURL(url)
    
    this.showNotification("JSON file downloaded!")
  }

  showNotification(message, type = "success") {
    // Create notification element
    const notification = document.createElement("div")
    notification.className = `fixed top-4 right-4 px-4 py-2 rounded-md text-white ${
      type === "success" ? "bg-green-600" : "bg-red-600"
    } shadow-lg z-50 transition-opacity duration-300`
    notification.textContent = message
    
    // Add to body
    document.body.appendChild(notification)
    
    // Remove after 2 seconds
    setTimeout(() => {
      notification.style.opacity = "0"
      setTimeout(() => {
        document.body.removeChild(notification)
      }, 300)
    }, 2000)
  }
}